import * as types from './types';

export default {
  [types.SET_IS_LOGGED](state, isLogged) {
    state.isLogged = isLogged;
  },
  [types.SET_IS_ADMIN](state, isAdmin) {
    state.isAdmin = isAdmin;
  },
  [types.SET_CURRENT_USER](state, currentUser) {
    state.currentUser = currentUser;
  },
  [types.SET_IS_ROUTE_AUTHORIZED](state, isRouteAuthorized) {
    state.isRouteAuthorized = isRouteAuthorized;
  },
};
